import { SweetAlertService } from 'ng2-cli-sweetalert2';
// @ANGULAR
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';

// MODELS
import { PinAddRequest } from '../../models/ss-api/requests/pin.add.request';
import { PinTypes } from '../../models/domain/pin';
import { MemberDashboard } from '../../models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../../models/ss-api/responses/templates.and.from.response';
import { TicketStatusTypes, TicketUrgencyTypes, CustomTicketItem } from '../../models/domain/custom.ticket.item';

// SERVICES
import { ssApiService } from '../../services/ss-api.service';
import { AdminHistoryService } from '../../services/admin.history.service';
import { GlobalService } from '../../services/global.service';
import { PinService } from '../../services/pin.service';

// MANAGERS
import { TicketManager } from '../../managers/ticket.manager';

// COMPONENTS
import { CKEditorComponent } from 'ng2-ckeditor';
import { Subscription } from 'rxjs';

// OTHER
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { SelectItem } from 'primeng/primeng';
import { TicketAssignAdminRequest } from '../../models/ss-api/requests/ticket.assign.admin.request';
import { AddCustomTicketReplyRequest } from '../../models/ss-api/requests/add.custom.ticket.reply.request';
import { EditCustomTicketRequest } from '../../models/ss-api/requests/edit.custom.ticket.request';
import { TicketAssignMemberRequest } from '../../models/ss-api/requests/ticket.assign.member.request';
import { UserRolesService } from '../../../app/services/user.roles.service';
import { TicketWindowTypes } from '../../dialog-windows/ticket/ticket.window';
import { LicenseManager } from '../../managers/License.manager';
import { AdminPermissionTypes } from '../../models/domain/admin.permission.item';
import { SortBot } from '../../helpers/sort';
import { AdminItemArray } from '../../models/domain/admin.item';

// Make me committ again

export interface ITicketDetailsDialogModel {
    TicketWindowType: TicketWindowTypes;
    TicketID: number;
    MemberID: number;
}


@Component({
    selector: 'ticket-details-dialog',
    templateUrl: './ticket.details.dialog.html',
    styleUrls: ['./ticket.details.dialog.css'],

})

export class TicketDetailsDialog extends DialogComponent<ITicketDetailsDialogModel, boolean> implements ITicketDetailsDialogModel, OnDestroy, OnInit {

    TicketWindowType: TicketWindowTypes = TicketWindowTypes.Internal;

    ticketManager: TicketManager;
    TicketID: number;
    Ticket: CustomTicketItem = new CustomTicketItem;

    TicketReplyLogArray: Array<any> = new Array<any>();

    isChanged: boolean = false;

    IsBusy: boolean = false;
    ChatIsBusy: boolean = false;
    SendEmail: boolean = true;

    AddReply: boolean = false;

    // browser Title
    private originalTitle: string;
    // subscriptions
    private ticketOnMemberAssign: Subscription;
    private ticketOnMemberUnassign: Subscription;


    // EMAIL TEMPLATE STUFF
    MemberData: MemberDashboard = new MemberDashboard();
    TemplatesAndFrom: TemplatesAndFromResponse = new TemplatesAndFromResponse;
    emailTemplate: string = '';
    emailTemplatePanel: boolean = false;

    TicketReplyMessage: string;

    // CHAT SCROLL WINDOW
    @ViewChild('chatWindow') private chatScrollWindow: ElementRef;
    @ViewChild('chatScrollContent') private chatScrollContent: ElementRef;

    @ViewChild('CKEDITOR') private CKEDITOR: CKEditorComponent;
    @ViewChild('SubjectEdit') SubjectEditField: ElementRef;

    MemberID: number = 0;
    TicketMemberID: number;

    user: SelectItem[];
    //selectedUser: number;

    status: SelectItem[];
    selectedStatus: number;


    disableScrollDown = false;

    MemberOptions: SelectItem[];
    SelectedMemberID: number = 0;

    UserOptions: SelectItem[];
    SelectedUser: number;

    StatusOptions: SelectItem[];

    UrgencyOptions: SelectItem[];
    SelectedUrgency: number;

    DueDate: Date;

    IsInternal: boolean;

    // EDIT FILED VARIABLES
    editAdminID: boolean = false;
    oldAdminID: number;
    editStatus: boolean = false;
    oldStatus: TicketStatusTypes;
    editMemberID: boolean = false;
    oldMemberID: number;
    editPriority: boolean = false;
    oldPriority: TicketUrgencyTypes;
    editInternal: boolean = false;
    oldInternal: boolean = false;
    editDueDate: boolean = false;
    oldDueDate: Date;

    ShowSubjectEdit: boolean = false;

    // CKEditor Config
    private CKEditorConfig = {
        allowedContent: true,
        resize_enabled: false,
        height: '100%',
        toolbarLocation: 'bottom'
    };

    constructor(dialogService: DialogService,
        private pinService: PinService,
        private api: ssApiService,
        public gb: GlobalService,
        public historyService: AdminHistoryService,
        private changeDetect: ChangeDetectorRef,
        public roles: UserRolesService,
        private sweetAlert: SweetAlertService,
        public router: Router) {
        super(dialogService, router);
    }

    //HotKey
    @HostListener('window:keydown.alt.t', ['$event'])
    saveTicketHotKey(event: KeyboardEvent) {
        event.preventDefault();
        this.SaveTicket();
        this.close();        
    }

    //HotKey
    @HostListener('window:keydown.alt.c', ['$event'])
    closeTicketHotKey(event: KeyboardEvent) {
        event.preventDefault();
        this.selectedStatus = 99;
        this.SaveTicket();
        this.close();        
    }

    //HotKey
    @HostListener('window:keydown.alt.d', ['$event'])
    async deleteTicketHotkey(event: KeyboardEvent) {
        event.preventDefault();

        this.IsBusy = true;

        let response = await this.api.DeleteCustomTicket(this.TicketID).toPromise();

        if (response.Result) {
            this.result = true;
            this.close();
            this.sweetAlert.swal({
                type: 'success',
                title: 'Ticket Deleted',
                timer: 1500
            }).then(() => { }, () => { });
        } else {
            this.sweetAlert.swal({
                type: 'error',
                title: 'Could Not Delete Ticket'
            }).then(() => { });
        }

        this.IsBusy = false;

        this.close();        
    }


    

    ngOnDestroy() {
        // this.titleService.setTitle(this.originalTitle);
    }

    ngOnInit() {
        this.Init();
        $('body .chatWindow').on('click', 'a', $.proxy(function (event) {
            let target = String(event.currentTarget['href']).replace('unsafe:', '');
            let uri = target.match(`^[^:]+\s*`)[0];
            let value = target.match(`:(.*)`)[1];
            if (!uri.includes('http')) {
                switch (uri) {
                    case 'cdkey':
                        this.IsBusy = true;
                        let manager = new LicenseManager();
                        manager.OnDataLoaded.subscribe(response => {
                            this.IsBusy = false;
                        });
                        manager.Load(value, true);
                        manager.OnChangesSaveResponse.subscribe(response => { });
                }
            }
        }, this));
    }


    async Init() {

        // this.TicketID = this.Context.Data.TicketID;
        // this.TicketWindowType = this.Context.Data.TicketWindowType;
        // this.MemberID = this.Context.Data.MemberID;

        this.IsBusy = true;

        this.TicketReplyLogArray = new Array<any>();

        await this.GetTicket();
        await this.InitStatus();
        await this.InitMemberOptions();
        await this.InitUserOptions();        

        await this.InitUrgencyOptions();
        this.DueDate = this.Ticket.DueDate;
        this.IsInternal = this.Ticket.IsInternal;
        // this.Ticket.DateTimeCreated


        this.changeDetect.detectChanges();
        //this.scrollChatToBottom();
        this.IsBusy = false;

        this.SetWindowTitle();

        this.GetTicketLogs();
    }

    ToggleSubjectEdit() {
        this.ShowSubjectEdit = !this.ShowSubjectEdit;
        setTimeout(() => {
            this.SubjectEditField.nativeElement.focus();
        }, 50);
    }


    SetWindowTitle() {

        // let newWindowTitle : string ="";

        // if( this.TicketWindowType == TicketWindowTypes.Internal )
        //   newWindowTitle += "Internal";
        // else
        //   newWindowTitle += "Support";

        // newWindowTitle += " Ticket | ID: " + this.Ticket.TicketID + " | subject: " + this.Ticket.Subject + " | member: " + this.Ticket.MemberName;

        // this.titleService.setTitle( newWindowTitle );

    }

    async GetTicket() {

        // console.log("Getting Ticket", this.TicketID);

        let response = await this.api.GetTicketByID(Number(this.TicketID)).toPromise();
        if (response.Result) {

            this.Ticket = response.Data;

            if (this.Ticket.Replies) {
                this.Ticket.Replies.forEach((reply) => {
                    this.TicketReplyLogArray.push(reply);
                });
            }

        } else { }
    }

    GetTicketLogs() {
        let disposable = this.api.AdminLogsByTicketID(Number(this.TicketID)).subscribe((response) => {
            response.Data.shift();
            if (response.Data.length > 0) {
                response.Data.forEach((log) => {
                    this.TicketReplyLogArray.push(log);
                });
            }
            disposable.unsubscribe();
        });
    }

    SortLogsByDate() {
        if (this.TicketReplyLogArray.length > 0) {
            this.TicketReplyLogArray.sort((left, right) => {
                if (left.DateTimeCreated > right.DateTimeCreated) {
                    return 1;
                } else {
                    return -1;
                }
            });

            return this.TicketReplyLogArray;
        }
    }

    originalMessageClass(): string {
        let myClasses: string = '';

        if (this.Ticket) {
            if (!this.Ticket.CreatedByAdmin)
                myClasses += 'member';
            else if (this.Ticket.CreatedByAdmin)
                if (this.Ticket.OriginalAdminID == this.gb.AdminId)
                    myClasses += 'me';
                else
                    myClasses += 'admin';
        }

        return myClasses;
    }

    private async InitStatus() {
        this.StatusOptions = [];

        this.StatusOptions.push({ label: 'New', value: TicketStatusTypes.New });
        this.StatusOptions.push({ label: 'In Progress', value: TicketStatusTypes.InProgress });

        this.StatusOptions.push({ label: 'Awaiting Member', value: TicketStatusTypes.AwaitingMemberResponse });
        this.StatusOptions.push({ label: 'Awaiting Admin', value: TicketStatusTypes.AwaitingAdminResponse });

        this.StatusOptions.push({ label: 'TOS', value: TicketStatusTypes.TOS });

        this.StatusOptions.push({ label: 'Closed', value: TicketStatusTypes.Closed });

        this.selectedStatus = this.Ticket.Status;

    }

    async InitUserOptions() {
        this.UserOptions = [];

        
        // set busy flag
        this.IsBusy = true;

        // do async request
        let adminResponse = await this.api.AdminsByPermissionType(AdminPermissionTypes.AppearInTicketingDropdown).toPromise();
        
        // reset busy flag
        this.IsBusy = false;

        // sort list of admins in new variable from result
        let admins = SortBot.SortAuto<AdminItemArray>(adminResponse.Data, 'FirstName');

        // add admins to combo list
        admins.forEach(admin => {
            if (admin.AdminID != this.gb.AdminId)
                this.UserOptions.push({ label: admin.FirstName + ' ' + admin.LastName, value: admin.AdminID });
        });

        // sort list
        this.UserOptions.sort((left, right) => {
            if (left.label > right.label) {
                return 1;
            } else {
                return -1;
            }
        });

        // add items to list
        this.UserOptions.unshift({ label: 'Me - ' + this.gb.FullName, value: this.gb.AdminId });
        this.UserOptions.unshift({ label: 'Don\'t Assign', value: 0 });
            
        // set selected user
        this.SelectedUser = this.Ticket.AdminID;       

    }


    async InitMemberOptions() {
        this.historyService.Refresh();
        // console.log("History", this.historyService.History);
        this.MemberOptions = [];
        this.MemberOptions.push({ label: 'None', value: 0 });
        this.MemberOptions.push({ label: this.Ticket.MemberName, value: this.Ticket.MemberID });

        this.historyService.History.forEach(x => {
            if (x.MemberID != null && x.MemberID != undefined) {
                this.MemberOptions.push({ label: x.MemberName, value: x.MemberID });
            }
        });

        this.SelectedMemberID = this.Ticket.MemberID;

    }

    MemberSelectChanged() {
        // console.log( "Selected Member ID: " + this.SelectedMemberID );
        if (this.SelectedMemberID == -1)
            this.SendEmail = false;
    }

    async InitUrgencyOptions() {
        this.UrgencyOptions = [];
        this.UrgencyOptions.push({ label: 'Low', value: TicketUrgencyTypes.Low });
        this.UrgencyOptions.push({ label: 'Normal', value: TicketUrgencyTypes.Normal });
        this.UrgencyOptions.push({ label: 'High', value: TicketUrgencyTypes.High });
        this.UrgencyOptions.push({ label: 'Super High', value: TicketUrgencyTypes.SuperHigh });
        this.SelectedUrgency = this.Ticket.Urgency;
    }

    confirm() {

        this.closeOK();

    }


    closeOK() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        // this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
        this.close();

    }

    showEmailTemplatePanel() {
        this.emailTemplatePanel = true;
    }

    updateEmailTemplate(newTemplate: string) {
        this.emailTemplate = newTemplate;
        this.TicketReplyMessage = newTemplate;
        this.emailTemplatePanel = false;
    }

    updateEmailAddress(e: any) {

    }

    updateSubject(e: any) {

    }

    cancelEmailTemplate() {
        this.emailTemplatePanel = false;
    }

    scrollChatToBottom(): void {
        try {
            this.chatScrollWindow.nativeElement.scrollTop = this.chatScrollWindow.nativeElement.scrollHeight;
        } catch (err) {

        }
    }

    scrollChatToTop(): void {
        try {
            this.chatScrollWindow.nativeElement.scrollTop = 0;
        } catch (err) {

        }
    }

    async showSelectEmailTemplate(e: any) {
        this.IsBusy = true;

        if (this.SelectedMemberID != undefined && this.SelectedMemberID != 0) {
            await this.api.getMemberDashboard(this.SelectedMemberID).toPromise().then(response => {
                this.MemberData = response.Data;
            }, error => {

            });

        }


        if (this.isTemplatesEmpty()) {
            let response = await this.api.GetEmailTemplatesBasicsAndFrom().toPromise();
            if (response.Result) {
                this.TemplatesAndFrom = response.Data;
            } else {

            }
        }

        this.IsBusy = false;

        this.emailTemplatePanel = true;
        this.changeDetect.detectChanges();
    }

    isTemplatesEmpty(): boolean {
        if (this.TemplatesAndFrom == null || this.TemplatesAndFrom == undefined)
            return true;
        else if (this.TemplatesAndFrom.Templates == null || this.TemplatesAndFrom.Templates == undefined || this.TemplatesAndFrom.Templates.length == 0)
            return true;
        else
            return false;
    }


    RemovePin() {
        // this.pinService.DeletePinByType(this.Ticket.TicketID, PinTypes.Ticket);
        this.changeDetect.detectChanges();
    }

    IsPinned(): boolean {
        // return this.pinService.IsPinned(this.Ticket.TicketID, PinTypes.Ticket);
        return true;
    }

    AddPin() {
        let request = new PinAddRequest();
        request.AdminID = this.gb.AdminId;
        request.PinType = PinTypes.Ticket;
        request.RelationID = this.Ticket.TicketID;
        this.pinService.Add(request);
    }

    SaveSettings() {

    }



    isMin: boolean = true;
    isMax: boolean = false;

    minimizeEditor() {
        if (this.isMin) {
            this.isMin = false;
        } else {
            this.isMin = true;
        }
        this.isMax = false;
        this.changeDetect.detectChanges();
        this.scrollChatToBottom();
    }


    maximizeEditor() {
        if (this.isMax) {
            this.isMax = false;
        } else {
            this.isMax = true;
        }
        this.isMin = false;
        this.changeDetect.detectChanges();
        this.scrollChatToBottom();
    }


    normalizeEditor() {
        if (this.isMin) {
            this.isMin = false;
            this.isMax = false;
            this.changeDetect.detectChanges();
            this.scrollChatToBottom();
        }
    }



    AdminChanged(e: any) {
        this.SetAsChanged(true);
    }


    SetAsChanged(newStatus: boolean) {
        this.isChanged = newStatus;
    }


    async SaveTicket() {

        this.IsBusy = true;

        let request = new EditCustomTicketRequest;

        // Ticket Values that may change ::
        request.AdminID = Number(this.SelectedUser); // Assigned To Field
        request.Status = this.selectedStatus;
        request.MemberID = this.Ticket.MemberID;
        request.Urgency = this.SelectedUrgency;
        request.DueDate = this.DueDate;

        // Ticket Values that don't change ::
        request.Body = this.Ticket.Body;
        request.CreatedByAdmin = this.Ticket.CreatedByAdmin;
        request.FromEmail = this.gb.Email;
        request.IsHTMLBody = true;
        request.IsInternal = this.IsInternal;
        request.SendEmail = this.SendEmail;
        request.Subject = this.Ticket.Subject;
        request.TicketID = this.TicketID;

        // Check to see if we need to update Admin On ticket
        if (this.oldAdminID != this.SelectedUser) {

            let adminRequest = new TicketAssignAdminRequest;
            adminRequest.AdminID = Number(this.SelectedUser);
            adminRequest.TicketID = this.TicketID;

            let adminResponse = await this.api.CustomTicketAssignAdmin(adminRequest).toPromise();

        }


        // Check to see if we need to update the Member on the ticket
        if (this.oldMemberID != this.SelectedMemberID) {

            let memberRequest = new TicketAssignMemberRequest;
            memberRequest.MemberID = Number(this.SelectedMemberID);
            memberRequest.TicketID = this.TicketID;

            let memberResponse = await this.api.CustomTicketAssignMember(memberRequest).toPromise();

        }


        // Do API Request to Update Ticket
        let disposable = this.api.EditCustomTicket(request).subscribe(result => {
            disposable.unsubscribe();
            // await this.Init();
            this.Init();

            this.SetAsChanged(false);

            this.IsBusy = false;
        }, error => {
            disposable.unsubscribe();
        });


    }

    async SendReply() {
        this.CKEDITOR.instance['commands']['source'].exec();
        this.CKEDITOR.instance['commands']['source'].exec();

        this.IsBusy = true;

        let request = new AddCustomTicketReplyRequest;
        request.AdminID = this.gb.AdminId;
        request.CreatedByAdmin = true;
        request.DueDate = this.Ticket.DueDate;
        request.FromEmail = this.gb.Email;
        request.IsHTMLBody = true;
        request.IsInternal = this.IsInternal;
        request.MemberID = this.SelectedMemberID;
        request.SendEmail = this.SendEmail;
        request.Status = this.selectedStatus;
        request.Subject = this.Ticket.Subject;
        request.TicketID = this.TicketID;
        request.Urgency = this.SelectedUrgency;
        request.Body = this.TicketReplyMessage;
        let response = await this.api.AddCustomTicketReply(request).toPromise();
        if (response.Result) {
            await this.Init();
        } else {

        }

        this.IsBusy = false;
        this.minimizeEditor();
        this.AddReply = false;
        this.changeDetect.detectChanges();
        this.scrollChatToBottom();
    }

    AddNewReply() {
        this.TicketReplyMessage = '';
        this.AddReply = true;
        this.normalizeEditor();
        // this.CKEDITOR.nativeElement.focus();
    }
    CKEDITORready(e: any) {
        // e.editor.focusManager.hasFocus = true;
    }


    GoToMember() {
        // this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.NavigateToMember, this.MemberID));
    }

    DeleteTicket() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are You Sure?',
            text: 'Deleting is permanent and cannot be reversed',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteCustomTicket(this.TicketID).toPromise();
            }
        }).then(response => {
            if (response.Result) {
                this.result = true;
                this.close();
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Ticket Deleted',
                    timer: 1500
                }).then(() => { }, () => { });
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Could Not Delete Ticket'
                }).then(() => { });
            }

        });
    }
}
